import { useContext, createContext } from 'react';

export const TokenContext = createContext({});

export function useTokenContext() {
  return useContext(TokenContext);
}
